export default function subString (String) {
  const str = String.slice(2)
  let s1 = str.substring(0, str.length - 2)
  s1 = s1.replace('\\"', '')
  s1 = s1.replace('\\"/', '')
  const arr = s1.split('","')
  // console.log(arr)
  return arr
}
